import React from "react";
import { Box, Divider, StackProps, Text, VStack } from "@chakra-ui/react";
import { ViewControl } from "../ViewControl/ViewControl";
import { TableListViewDictionary } from "./TableListViewDictionary";

interface ListViewDictionaryProps<T> {
  dictionary?: { [key: string]: T } | null;
  emptyMessage?: string;
  format?: (value: [string, T]) => React.ReactNode;
}

export function ListViewDictionary<T>({
  dictionary,
  emptyMessage,
  format,
  ...props
}: ListViewDictionaryProps<T> & StackProps) {
  const formatValue = ([key, value]: [string, any]) => {
    if (value == null) return <ViewControl label={key} value="-" />;

    switch (typeof value) {
      case "object":
        return (
          <ViewControl label={key}>
            <TableListViewDictionary dictionary={value as any} flex={3} />
          </ViewControl>
        );
      case "boolean":
        return (
          <ViewControl
            label={key}
            value={value == true ? "Yes" : value == false ? "No" : "-"}
          />
        );

      default:
        return <ViewControl label={key} value={value ?? "-"} />;
    }
  };

  return (
    <VStack w="100%" alignItems="flex-start" {...props}>
      {(dictionary &&
        Object.keys(dictionary).length &&
        Object.entries(dictionary).map((value, idx) => (
          <Box w="100%" key={idx}>
            {format ? format(value) : formatValue(value)}
            {idx != Object.keys(dictionary).length - 1 && (
              <Divider
                variant="section-box"
                marginInlineStart="-1rem !important"
                w="calc(100% + 2rem)"
              />
            )}
          </Box>
        ))) || (
        <Text fontStyle="italic">{emptyMessage ?? "List is empty"}</Text>
      )}
    </VStack>
  );
}
